/*
  AUTOPRO-TILFØJELSE (2026-08-28, rettet 6. gange + tilføjet loading-indikator
  samme dag): Kobler land/valuta-valg sammen med sprogvalg, så valg af land
  automatisk vælger det tilhørende
  sprog — men kunden kan altid manuelt overstyre sprogvalget bagefter, og det
  respekteres derefter (permanent i localStorage), MED ÉN undtagelse: vælger
  kunden på et tidspunkt selv det sprog der rent faktisk matcher det aktuelt
  valgte land, fjernes overstyringen igen, så fremtidige landskift atter
  auto-kobler sproget.

  3. RETTELSE (3 forsøg): Landevalg i den native Shopify-vælger sender først
  en asynkron forespørgsel af sted for at gemme det nye land, og laver FØRST
  bagefter en rigtig sidegenindlæsning når den er færdig — varigheden er
  uforudsigelig (nogle gange <500ms, andre gange flere sekunder). To forsøg
  med faste tidsfrister (beforeunload-flag, derefter "stol på det periodiske
  scan i stedet") virkede stadig ikke konsekvent, fordi BEGGE stadig gættede
  på et tidspunkt frem for at bekræfte at landet faktisk var skiftet, inden
  sproget blev klikket.
  Rigtig løsning: gem hvilket land sprogvalget hører til (PENDING_COUNTRY_KEY)
  sammen med selve sprogmålet. Sprogvalget bliver ALDRIG anvendt før
  Shopify.country på den aktuelle side rent faktisk matcher det land der blev
  klikket — indtil da gør applyPendingLanguage() ingenting og prøver bare
  igen ved næste periodiske scan (hvert 500ms) eller efter næste rigtige
  sidegenindlæsning. Ingen gætning om tidspunkter længere - kun bekræftet
  tilstand.

  4. RETTELSE: Selv efter ovenstående var der STADIG lejlighedsvise fejl, nu
  af en helt anden årsag: Athens-temaet renderer BÅDE en Header- og en
  MobileMenu-udgave af sprogvælgeren samtidig i DOM'en (to adskilte <ul>
  med hver sit "nl"-link osv.). applyPendingLanguage() klikkede tidligere
  BEGGE i samme tick - to konkurrerende sprogskift der nogle gange
  modarbejdede hinanden så INGEN af dem gennemførte navigationen. Rettet
  til kun at klikke den FØRSTE fundne match.

  5. RETTELSE: Selv ÉT enkelt klik bliver nogle gange bare stille ignoreret
  af den native vælger (ingen fejl, ingen navigation - formentlig fordi
  komponenten stadig anser sig selv som "optaget" lige efter landeskiftets
  egen indsendelse). Et manuelt gentaget klik virkede altid. Rettet ved at
  IKKE fjerne PENDING_KEY før Shopify.locale rent faktisk matcher målet -
  så bliver et forgæves klik automatisk gentaget af det periodiske scan
  (hvert 500ms) i stedet for at give permanent op efter første forsøg.

  6. RETTELSE: Rettelse 5 fungerede, men var alt for LANGSOM live (15-20+
  sekunder for at ramme det korrekte sprog) - fordi et klik faktisk STARTER
  en rigtig sideindsendelse, og et nyt klik 500ms senere (fra næste scan,
  da Shopify.locale endnu ikke er opdateret) AFBRYDER den igangværende
  indsendelse og starter en ny, i det uendelige, indtil to forsøg tilfældigt
  ramte langt nok fra hinanden til at én kunne nå at lande. Rettet ved at
  vente mindst RETRY_GAP_MS (3 sek.) mellem hvert reelt klik-forsøg, så en
  igangværende indsendelse får ro til at fuldføre, før vi overhovedet
  overvejer at klikke igen.

  LOADING-INDIKATOR: Da et landeskifte uden sidegenindlæsning (AJAX-tilfælde)
  ikke giver kunden noget synligt tegn på at der sker noget i de - typisk 3-8,
  værste fald op til 20 - sekunder det tager, vises en lille fast blå "vent
  lidt"-boble øverst midt på skærmen mens vi venter, med teksten på kundens
  NUVÆRENDE sprog (12 sprog understøttet, engelsk som fallback). Forsvinder
  automatisk så snart sproget rent faktisk er skiftet, ved manuel overstyring,
  eller senest efter LOADER_MAX_MS som sikkerhedsnet.

  2. RETTELSE: Der findes reelt TO helt uafhængige selector-systemer på siden
  samtidig:
    1) T Lab-appens egne lister: <li class="tl-option" data-value="de">
       (data-value sidder PÅ selve li'et)
    2) Athens-temaets INDBYGGEDE native sprog/land-vælger (Shopify's egen
       localization-form, id'er som #HeaderLanguageListHeader /
       #HeaderCountryListHeader + MobileMenu-varianter): her sidder
       data-value derimod på et <a>-link INDE I li'et, ikke på li'et selv.
  Kunden ser og bruger i praksis den native variant (den simple "EN ▾" uden
  flag), som første og anden version af scriptet slet ikke fangede, fordi de
  kun ledte efter data-value direkte på li-elementer.

  Denne version leder generisk efter ALLE elementer med [data-value] der
  matcher et land- eller sprogkode-moenster, uanset om det sidder paa li'et
  selv eller et link/knap indeni - og finder dermed alle varianter af begge
  systemer (T Lab OG native, Header- og MobileMenu-udgaver) uden at skulle
  kende hvert enkelt id/klassenavn paa forhaand.
*/
(function () {
  var COUNTRY_TO_LANG = {
    AT: 'de', BE: 'fr', CZ: 'cs', DK: 'da', FI: 'fi', FR: 'fr',
    DE: 'de', IT: 'it', LU: 'fr', NL: 'nl', NO: 'no', PL: 'pl',
    ES: 'es', SE: 'sv',
  };
  var PENDING_KEY = 'ap_pending_lang_target';
  var PENDING_COUNTRY_KEY = 'ap_pending_lang_for_country';
  var LAST_ATTEMPT_KEY = 'ap_lang_last_attempt';
  var RETRY_GAP_MS = 3000;
  var MANUAL_KEY = 'ap_lang_manual_override';
  var COUNTRY_RE = /^[A-Z]{2}$/;
  var LANG_RE = /^[a-z]{2}$/;

  // Synlig "vent lidt"-indikator mens land/sprog skiftes i baggrunden - uden
  // den ser kunden intet ske i op til nogle sekunder (se rettelse 6 ovenfor),
  // hvilket let kan opfattes som at siden hænger eller er "død".
  var LOADER_ID = 'ap-lang-loading-indicator';
  var LOADER_STARTED_KEY = 'ap_lang_loader_started';
  var LOADER_MAX_MS = 20000;
  var LOADER_TEXT = {
    da: 'Indlæser ønsket sprog og område…',
    en: 'Loading your preferred language and region…',
    de: 'Bevorzugte Sprache und Region werden geladen…',
    fr: 'Chargement de la langue et de la région…',
    es: 'Cargando idioma y región preferidos…',
    it: 'Caricamento di lingua e area preferite…',
    nl: 'Voorkeurstaal en regio laden…',
    no: 'Laster ønsket språk og område…',
    pl: 'Ładowanie preferowanego języka i regionu…',
    fi: 'Ladataan haluttua kieltä ja aluetta…',
    sv: 'Laddar önskat språk och område…',
    cs: 'Načítání preferovaného jazyka a oblasti…',
  };

  function showLoader() {
    if (!localStorage.getItem(LOADER_STARTED_KEY)) {
      localStorage.setItem(LOADER_STARTED_KEY, String(Date.now()));
    }
    if (!document.body) return;
    var el = document.getElementById(LOADER_ID);
    if (!el) {
      if (!document.getElementById(LOADER_ID + '-style')) {
        var style = document.createElement('style');
        style.id = LOADER_ID + '-style';
        style.textContent = '@keyframes apLangSpin{to{transform:rotate(360deg)}}';
        document.head.appendChild(style);
      }
      el = document.createElement('div');
      el.id = LOADER_ID;
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'position:fixed;top:1.6rem;left:50%;transform:translateX(-50%);' +
        'z-index:99999;display:flex;align-items:center;gap:0.9rem;background:#0244a9;' +
        'color:#fff;padding:1rem 1.8rem;border-radius:999px;box-shadow:0 4px 18px rgba(0,0,0,.22);' +
        'font:500 1.3rem/1.3 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;' +
        'pointer-events:none;';
      var spinner = document.createElement('span');
      spinner.style.cssText = 'width:1.4rem;height:1.4rem;border-radius:50%;flex:0 0 auto;' +
        'border:2px solid rgba(255,255,255,.35);border-top-color:#fff;animation:apLangSpin .7s linear infinite;';
      var label = document.createElement('span');
      label.id = LOADER_ID + '-label';
      el.appendChild(spinner);
      el.appendChild(label);
      document.body.appendChild(el);
    }
    var lang = (window.Shopify && Shopify.locale) || 'en';
    var labelEl = document.getElementById(LOADER_ID + '-label');
    if (labelEl) labelEl.textContent = LOADER_TEXT[lang] || LOADER_TEXT.en;
    el.style.display = 'flex';
  }

  function hideLoader() {
    localStorage.removeItem(LOADER_STARTED_KEY);
    var el = document.getElementById(LOADER_ID);
    if (el) el.style.display = 'none';
  }

  function closestList(el) {
    return el.closest('ul, ol, [role="listbox"], [role="list"]') || el.parentElement;
  }

  function findAllLists() {
    var countryLists = [], langLists = [];
    var nodes = document.querySelectorAll('[data-value]');
    nodes.forEach(function (node) {
      var v = node.getAttribute('data-value');
      var list = closestList(node);
      if (!list) return;
      if (COUNTRY_RE.test(v)) {
        if (countryLists.indexOf(list) === -1) countryLists.push(list);
      } else if (LANG_RE.test(v)) {
        if (langLists.indexOf(list) === -1) langLists.push(list);
      }
    });
    return { countryLists: countryLists, langLists: langLists };
  }

  function applyPendingLanguage() {
    var target = localStorage.getItem(PENDING_KEY);
    if (!target) {
      hideLoader();
      return;
    }
    if (localStorage.getItem(MANUAL_KEY)) {
      localStorage.removeItem(PENDING_KEY);
      localStorage.removeItem(PENDING_COUNTRY_KEY);
      localStorage.removeItem(LAST_ATTEMPT_KEY);
      hideLoader();
      return; // kunden har selv valgt sprog siden - rør ikke
    }
    if (window.Shopify && Shopify.locale === target) {
      // maalet er allerede naaet (evt. af et tidligere klik) - faerdig
      localStorage.removeItem(PENDING_KEY);
      localStorage.removeItem(PENDING_COUNTRY_KEY);
      localStorage.removeItem(LAST_ATTEMPT_KEY);
      hideLoader();
      return;
    }
    // Sikkerhedsnet: giv aldrig permanent op indenfor selve sessionen, men
    // fjern heller aldrig indikatoren fra skærmen for evigt hvis noget
    // uforudset går galt - efter LOADER_MAX_MS opgives forsøget stille.
    var loaderStarted = parseInt(localStorage.getItem(LOADER_STARTED_KEY) || '0', 10);
    if (loaderStarted && Date.now() - loaderStarted > LOADER_MAX_MS) {
      localStorage.removeItem(PENDING_KEY);
      localStorage.removeItem(PENDING_COUNTRY_KEY);
      localStorage.removeItem(LAST_ATTEMPT_KEY);
      hideLoader();
      return;
    }
    showLoader();
    var expectedCountry = localStorage.getItem(PENDING_COUNTRY_KEY);
    var currentCountry = window.Shopify && Shopify.country;
    if (expectedCountry && currentCountry !== expectedCountry) {
      return; // landet har endnu ikke naaet at skifte paa DENNE side - proev igen ved naeste scan
    }
    // Giv en tidligere indsendelse ro til at naa frem, foer vi proever igen -
    // at klikke for tidligt/for tit afbryder en igangværende sidenavigation
    // og genstarter den forfra i det uendelige (set live: sprogskiftet tog
    // 15-20+ sekunder fordi hvert 500ms-forsøg konstant afbrød det forrige).
    var lastAttempt = parseInt(localStorage.getItem(LAST_ATTEMPT_KEY) || '0', 10);
    if (Date.now() - lastAttempt < RETRY_GAP_MS) {
      return;
    }
    localStorage.setItem(LAST_ATTEMPT_KEY, String(Date.now()));
    // BEVIDST: PENDING_KEY fjernes IKKE her. Den native sprog-vælger kan
    // stille og roligt IGNORERE et klik (fx hvis den stadig er "optaget" af
    // landeskiftets egen indsendelse) uden fejl og uden navigation - så det
    // er umuligt at vide her om klikket faktisk virkede. Ved at lade
    // PENDING_KEY blive stående prøver det periodiske scan igen af sig selv
    // (med mindst RETRY_GAP_MS mellem hvert forsøg), indtil Shopify.locale
    // rent faktisk matcher (tjekket øverst i funktionen) - så stopper det
    // helt af sig selv.
    var lists = findAllLists().langLists;
    for (var i = 0; i < lists.length; i++) {
      var el = lists[i].querySelector('[data-value="' + target + '"]');
      if (el) {
        el.click();
        break;
      }
    }
  }

  function bind() {
    var lists = findAllLists();

    lists.langLists.forEach(function (list) {
      if (list.dataset.apBound) return;
      list.dataset.apBound = '1';
      list.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        var target = e.target.closest('[data-value]');
        if (!target) return;
        var picked = target.getAttribute('data-value');
        var currentCountry = window.Shopify && Shopify.country;
        var expectedLang = currentCountry && COUNTRY_TO_LANG[currentCountry];
        if (expectedLang && picked === expectedLang) {
          // kunden valgte selv det sprog der matcher det aktuelle land igen -
          // fjern overstyringen, så fremtidige landskift atter auto-kobler
          localStorage.removeItem(MANUAL_KEY);
        } else {
          localStorage.setItem(MANUAL_KEY, '1');
        }
      }, true);
    });

    lists.countryLists.forEach(function (list) {
      if (list.dataset.apBound) return;
      list.dataset.apBound = '1';
      list.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        var target = e.target.closest('[data-value]');
        if (!target) return;
        var country = target.getAttribute('data-value');
        var lang = COUNTRY_TO_LANG[country];
        if (!lang || localStorage.getItem(MANUAL_KEY)) return;
        localStorage.setItem(PENDING_KEY, lang);
        localStorage.setItem(PENDING_COUNTRY_KEY, country);
        showLoader(); // vis straks - ellers ser kunden intet ske i op til flere sekunder
        // Klikker IKKE sproget herfra. applyPendingLanguage() (kaldt af det
        // periodiske scan nedenfor, og af enhver frisk sidegenindlæsning)
        // venter selv til Shopify.country rent faktisk matcher "country" -
        // ingen gætning om tidspunkter, kun bekræftet tilstand.
      }, true);
    });

    return lists.countryLists.length > 0 || lists.langLists.length > 0;
  }

  function init() {
    bind();
    applyPendingLanguage(); // reload-tilfaelde: fortsaet efter ny sideindlaesning
  }

  init();
  // Bliv ved med at scanne periodisk, saa alle varianter bindes naar de dukker
  // op (kan indlaeses paa forskellige tidspunkter / gen-renderes efter AJAX).
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    init();
    if (tries > 60) clearInterval(poll); // ca. 30 sek
  }, 500);
})();
